// NOTE: run this *before* any block using 'namespace()'
(function () {
  'use strict';
  
  window.namespace = namespace;

  // Ref.: http://elegantcode.com/2011/01/26/basic-javascript-part-8-namespaces/
  // Usage: var model = namespace('myCompany.myApplication.model'); model.Podcast = function () {};
  function namespace(namespaceString) {
    var parts = namespaceString.split('.'),
        parent = window,
        currentPart = '';    
        
    for(var i = 0, length = parts.length; i < length; i++) {
        currentPart = parts[i];
        parent[currentPart] = parent[currentPart] || {};
        parent = parent[currentPart];
    }
    
    return parent;
  }
  
})();

// NOTE: run this *before* any ready-handler block
(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  function OnReadyManager() {
    var onReadyActions = [];
    
    this.addHandler = function addHandler(action) {
      onReadyActions.push(action);
    };
    
    this.runOnReadyActions = function runOnReadyActions() {
      onReadyActions.forEach(function (action) { 
        action(); 
      });
    };
  }
  
  floyd.onReadyManager = new OnReadyManager();

})(jQuery);

// === BEGIN ready-handler blocks ===

(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initTextAndPictureSliders);
  
  // arrange text slider and picture slider to switch in sync
  function initTextAndPictureSliders() {
    var textSliderItems = $('.home-slider');

    // text slider will act as the slave, stop its animation
    textSliderItems.flexslider('stop');
    
    // picture slider will act as the master
    $(window).on('backstretch.before', function (evt, instance, index) {
      // when picture slide changes, change also text slide
      textSliderItems.flexslider(index);
    });
    
  }

})(jQuery);

(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initCollapsedSections);
  
  function initCollapsedSections() {
    var $expandButtons = $('.section-collapsed-container .expand-collapse-button');
    var $collapsibleContainers = $expandButtons.parent();
    
    $expandButtons
      .click(onContentExpandCollapseClick)
      .removeClass('hidden');
    
    $collapsibleContainers
      .removeClass('expanded');
  }
  
  function onContentExpandCollapseClick(evt) {
    var $this = $(evt.currentTarget);
    var $container = $this.closest('.section-collapsed-container');
    var $content = $container.find('.section-content');
    
    var isExpanded = $container.hasClass('expanded');
    
    if (isExpanded) {
      // collapse content
      $container.removeClass('expanded');
    }
    else {
      // expand content
      $container.addClass('expanded');
    }
  }

})(jQuery);

(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initPortfolioProjects);
  
  function initPortfolioProjects() {
    $('.open-project').off();  // remove original parent theme click handler
    
    $('.open-project').click(onPortfolioProjectGalleryOpenClick);
    $('.close-project').click(onPortfolioProjectCardCloseClick);
  }
  
  function onPortfolioProjectGalleryOpenClick(evt) {
    var 
      $this            = $( evt.currentTarget ),
      $section         = $this.closest( 'section' ),
      $projectContent  = $section.find( '.project-content' ),
      $projectExtended = $section.find( '.project-extended' ),
      $portfolioBottom = $section.find( '.portfolio-bottom' );

    var projectUrl = $this.attr("href");
    
    // BrainCrumbz Customisation: Close project card if same project already open
    // BEGIN
    var extendedProjectUrl = $projectExtended.data('projectUrl') || '';
    
    if ($projectExtended.hasClass('open')) {
      resetOpenState(evt.currentTarget);
      
      if (projectUrl == extendedProjectUrl) {
        var $projectCloseButton = $projectExtended.find('.close-project');
        $projectCloseButton.click();
        
        return false;
      }
    }
    
    var $anchor = $this;
    $anchor.toggleClass('open');
    // END

    // BrainCrumbz Customisation: Changed animation magic numbers
    
    $projectContent.animate({opacity:0}, /*400*/100,function() {

      //Project Page Open
      $projectExtended.slideUp(/*600*/150, function() {

        if ( $projectExtended.hasClass( 'open' ) ) {

          $('html, body').animate({ scrollTop: $portfolioBottom.offset().top }, /*900*/300);
          $projectContent.load(projectUrl + ' #project', function() {

            // BrainCrumbz Customisation: store current project URL in card, as a unique identifier 
            $projectExtended.data('projectUrl', projectUrl);
          
            $( '.responsive-video' ).fitVids();
            $projectContent.animate({opacity:1}, /*400*/100);

            $projectExtended.delay(/*500*/100).slideDown(/*600*/300,function() {
              $projectContent.fadeIn('slow',function() {
                if ( $section.find( '.project-slider' ).length > 0 ) {
                  initProjectSlider();
                }
              });
            });

          });

        } else {

          $projectExtended.addClass('open');
          $('html, body').animate({ scrollTop: $portfolioBottom.offset().top - 30 }, /*900*/300);
          $projectContent.load(projectUrl + ' #project', function() {

            // BrainCrumbz Customisation: store current project URL in card, as a unique identifier 
            $projectExtended.data('projectUrl', projectUrl);

            $( '.responsive-video' ).fitVids();
            $projectContent.animate({opacity:1}, /*400*/100);
            
            $projectExtended.slideDown(/*600*/400, function() {
              $projectContent.fadeIn('slow',function() {
                if ( $section.find( '.project-slider' ).length > 0 ) {
                  initProjectSlider();
                }
              });
            });

          });

        }

      });
      
    }); 

    return false;      
  }
  
  function onPortfolioProjectCardCloseClick(evt) {
    resetOpenState(evt.currentTarget);
  }
  
  function resetOpenState(childElem) {
    var $childElem = $(childElem);
    var $section = $childElem.closest('section');
    var $galleryAnchor = $section.find('a.open');
    var $projectExtended = $section.find('.project-extended');
    
    $galleryAnchor.removeClass('open');

    $projectExtended.removeData('projectUrl');
  }

  //Portfolio project slider
  function initProjectSlider() {
    $('.project-slider').flexslider({
      prevText: "",
      nextText: "",
      useCSS: false,
      animation: "slide"
    });
  }

})(jQuery);

(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initOurNumbers);
  
  function initOurNumbers() {
    setCoffeeCount();
  }
  
  function setCoffeeCount() {
    var $icon = $('.counter.number i.fa-coffee');
    
    if ($icon.length === 0) return;  // quit if no coffee counter exists
    
    var coffeeCount = calcCoffeeCount();
    
    var $valueItem = $icon.next('.value');
    
    $valueItem.data('to', coffeeCount);
  }
  
  function calcCoffeeCount() {
    var startDay = 1, startMonth = 1, startYear = 2012;
    var startDate = new Date(startYear, startMonth - 1, startDay);  // month counts from 0
    
    var endDate = new Date();  // now
    
    var businessDays = calcBusinessDays(startDate, endDate);
    var coffeePerDay = 8;
    
    var coffeeCount = businessDays * coffeePerDay;
    
    return coffeeCount;
  }
  
  // Presa da http://snipplr.com/view/4086/calculate-business-days-between-two-dates/
  function calcBusinessDays(dDate1, dDate2) {        // input given as Date objects
   
    var iWeeks, iDateDiff, iAdjust = 0;
   
    if (dDate2 < dDate1) return -1;                  // error code if dates transposed
   
    var iWeekday1 = dDate1.getDay();                 // day of week
    var iWeekday2 = dDate2.getDay();
   
    iWeekday1 = (iWeekday1 === 0) ? 7 : iWeekday1;   // change Sunday from 0 to 7
    iWeekday2 = (iWeekday2 === 0) ? 7 : iWeekday2;
   
    if ((iWeekday1 > 5) && (iWeekday2 > 5)) iAdjust = 1;  // adjustment if both days on weekend
   
    iWeekday1 = (iWeekday1 > 5) ? 5 : iWeekday1;     // only count weekdays
    iWeekday2 = (iWeekday2 > 5) ? 5 : iWeekday2;
   
    // calculate differnece in weeks (1000mS * 60sec * 60min * 24hrs * 7 days = 604800000)
    iWeeks = Math.floor((dDate2.getTime() - dDate1.getTime()) / 604800000);
   
    if (iWeekday1 <= iWeekday2) {
      iDateDiff = (iWeeks * 5) + (iWeekday2 - iWeekday1);
    } else {
      iDateDiff = ((iWeeks + 1) * 5) - (iWeekday1 - iWeekday2);
    }
   
    iDateDiff -= iAdjust;                            // take into account both days on weekend
   
    return (iDateDiff + 1);                          // add 1 because dates are inclusive
   
  }
  
})(jQuery);

(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initLanguageSwitcher);
  
  function initLanguageSwitcher() {
    fixSwitcherHeight();
  }
  
  function fixSwitcherHeight() {
    // add invisible text inside anchor to fix height (IMG does not count for line-height)
    
    var $flagImg = $('.navbar .navbar-nav .lang-item a img');
    
    $flagImg.after('&nbsp;');
  }
  
})(jQuery);

(function ($) {
  'use strict';
  
  var $document = $(document);
  var $html;
  
  var $homeSection;
  var isHome;
  var homeHeight;
  var loggedIn;
  var $navbar;
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initNavBarForAll);
  
  function initNavBarForAll() {
    setCommonVars();
    initNavbarZoomAndFixed();
  }
  
  function setCommonVars() {
    $html = $('html');
    
    $homeSection = $('.home-first-section');
    isHome = !!($homeSection.length);
      
    var $loggedInBar = $('.logged-in');
    loggedIn = !!($loggedInBar.length);
    
    $navbar = $('.navbar');
  }
  
  function initNavbarZoomAndFixed() {
    
    updateHomeHeight();
    updateNavBarZoom();
    
    $document.scroll(updateNavBarZoom);
    
    // Original theme updates fixed menu only for home page. Do that for common pages too.
    if (! isHome) {
      updateNavBarFixed();
      
      $document.scroll(updateNavBarFixed);
    }

    $(window).resize(function() {
      updateHomeHeight();

      $document.scroll();
    });
  }
  
  function updateHomeHeight() {
    var height = $homeSection.height() || 0;
    homeHeight = (loggedIn ? height + 32 : height);
  }

  function updateNavBarZoom() {
    if ($document.scrollTop() > homeHeight) {
      $navbar.addClass('navbar-regular').removeClass('navbar-large');
    } 
    else {
      $navbar.addClass('navbar-large').removeClass('navbar-regular');
    }
  }
  
  function updateNavBarFixed() {
    if ($document.scrollTop() > homeHeight) {
      $navbar.addClass('navbar-fixed-top');
      $html.addClass('has-fixed-nav');
    } 
    else {
      $navbar.removeClass('navbar-fixed-top');
      $html.removeClass('has-fixed-nav');
    }
  }

})(jQuery);

(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(fixMenuNavigation);
  
  var loggedIn;
  
  function fixMenuNavigation() {
    // fix original theme menu navigation when current URL lacks the trailing slash
    
    var $loggedInBar = $('.logged-in');
    loggedIn = !!( $loggedInBar.length );
  
    $('.navbar .navbar-nav a[href*="#"]').click(onNavigationAnchorClick);
  }
  
  function onNavigationAnchorClick(evt) {
    // main implementation taken from theme original handler at floyd\js\main.js, #54
    
    var anchor = evt.currentTarget;
    
    // skip completely if original handler can kick in
    if (originalHandlerMatches(anchor)) {
      return;
    }
    
		if (fixedMatches(anchor)) {
      var hash = anchor.hash;
      var target = $(hash);
      
      if (! target.length) {
        target = $('[name=' + hash.slice(1) +']');
      }
      
			if (target.length) {
				$('html,body').animate({
					scrollTop: ( loggedIn ) ? target.offset().top - 32 : target.offset().top
				}, 1000);
        
				return false;
			}
		}
  }
  
  function originalHandlerMatches(anchor) {
    // this is the same condition tested in original handler: it fails if current location lacks the trailing slash
    var result = 
      location.pathname.replace(/^\//,'') == anchor.pathname.replace(/^\//,'') && 
      location.hostname == anchor.hostname && 
      anchor.hash !== '';
    
    return result;
  }
  
  function fixedMatches(anchor) {
    // this takes original handler condition and extends it so to also match if current location lacks the traling slash
    var result = 
      location.pathname.replace(/^\//,'').replace(/\/$/,'') == anchor.pathname.replace(/^\//,'').replace(/\/$/,'') && 
      location.hostname == anchor.hostname && 
      anchor.hash !== '';
    
    return result;
  }

})(jQuery);

(function ($) {
  'use strict';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initContactForm);
  
  function initContactForm() {
    shortenSendButtonAnimation();
  }
  
  function shortenSendButtonAnimation() {
    var $sendButton = $('#contact-form .peThemeContactForm input[type="submit"]');
    
    $sendButton.attr('data-animation', 'fadeInUp');
  }

})(jQuery);

(function ($) {
  'use strict';
  
  var originalMapSelector = '#map';
  var customMapSelector = '#greenMap';
  var customMapId = 'greenMap';
  
  var floyd = namespace('braincrumbz.floyd');
  
  floyd.onReadyManager.addHandler(initGoogleMap);
  
  function initGoogleMap() {
    disableOriginalMap();
    initCustomMap();
  }
  
  function disableOriginalMap() {
    // this runs before original map initialization from parent theme. 
    // initialization is based on specific element ID: change that to disable it
    
    var $map = $(originalMapSelector);

    if (! $map.length) return;
    
    $map.prop('id', customMapId);
  }
  
  function initCustomMap() {
    google.maps.event.addDomListener(window, 'load', onGoogleMapWindowLoad);
  }
  
  function onGoogleMapWindowLoad() {
    // mostly copied from original Floyd theme, from initMap() in wp-content\themes\floyd\js\main.js in
    // but without setting any style 
    
    var $map = $(customMapSelector);

    if (! $map.length) return;

    var myLatlng = new google.maps.LatLng($map.data('lat'), $map.data('lon')); // User set latitude and longitude
    
    var mapOptions = {
      zoom             : $map.data('zoom'), // User set zoom level
      center           : myLatlng,
      mapTypeControl   : false,
      disableDefaultUI : true,
      zoomControl      : false,
      scrollwheel      : false,
      styles           : [],
      draggable        : false
    };
    
    var map = new google.maps.Map(document.getElementById(customMapId), mapOptions);
    
    var marker = new google.maps.Marker({
        position: myLatlng,
        map: map
    });
  }

})(jQuery);

// === END ready-handler blocks ===

// NOTE: run this *after* any ready-handler block
(function ($) {
  'use strict';

  $(document).ready(function () {
    var floyd = namespace('braincrumbz.floyd');
    
    floyd.onReadyManager.runOnReadyActions();
  });
  
})(jQuery);

(function ($) {
  'use strict';
  
  $(window).on('load', onWindowLoad);
  
  function onWindowLoad(evt) {
    var relaxingInterval = 1000;
    
    setTimeout(preloadProjectDetails, relaxingInterval);
  }
  
  function preloadProjectDetails() {
  
    var projectDetailPageUrls = $('.portfolio-grid li a.open-project').map(function () { 
      return $(this).attr('href'); 
    }).get();
    
    var promiseSeed = $().promise();
    
    // start pre-loading detail page in sequence, one after the other
    
    projectDetailPageUrls.reduce(function (curr, next) {
    
      return curr.then(function () {
        return $.get(next);
      });
      
    }, promiseSeed);
  }

})(jQuery);
